import { ArrowLeft, Mail, MapPin, Building2, Globe } from "lucide-react";
import Navbar from "../components/Navbar";
import SiteFooter from "../components/Footer";
import { useLanguage } from "../context/LanguageContext";
import { usePages } from "../translations/pages";

const ContactPage = () => {
  const { language } = useLanguage();
  const tp = usePages(language);
  const c = tp.contact;
  return (
    <div className="min-h-screen bg-white" data-testid="contact-page">
      <Navbar isScrolled={true} />
      <div className="wrap-cayus pt-28 pb-16">
        {/* Back link */}
        <a
          href="/"
          className="inline-flex items-center gap-2 text-sm text-[#5E6C83] hover:text-[#1B1B1B] mb-10 transition-colors"
          data-testid="contact-back-link"
        >
          <ArrowLeft className="w-4 h-4" />
          {tp.back}
        </a>

        <div className="rule-cobalt mb-5" />
        <p className="mono-cayus text-[#0047AB] mb-4">{c.eyebrow}</p>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1B1B1B] tracking-tight mb-3">
          {c.title}
        </h1>
        <p className="text-base text-[#4D4D4D] mb-10 leading-relaxed">
          {c.lead}
        </p>

        {/* Contact cards */}
        <div className="grid sm:grid-cols-2 gap-5 mb-12">
          {/* General enquiries */}
          <div className="bg-[#F7F9FC] border border-[#ECECEC] rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#1d4ed8]/10 rounded-xl flex items-center justify-center">
                <Mail className="w-5 h-5 text-[#1d4ed8]" />
              </div>
              <h2 className="font-bold text-lg text-[#1B1B1B]">{c.generalTitle}</h2>
            </div>
            <p className="text-sm text-[#4D4D4D] mb-3">{c.generalText}</p>
            <a href="mailto:renaud@cayus.ai" className="text-[#1d4ed8] font-medium hover:underline text-sm">
              renaud@cayus.ai
            </a>
          </div>

          {/* Privacy */}
          <div className="bg-[#F7F9FC] border border-[#ECECEC] rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-emerald-500/10 rounded-xl flex items-center justify-center">
                <Globe className="w-5 h-5 text-[#10B981]" />
              </div>
              <h2 className="font-bold text-lg text-[#1B1B1B]">{c.privacyTitle}</h2>
            </div>
            <p className="text-sm text-[#4D4D4D] mb-3">{c.privacyText}</p>
            <a href="mailto:privacy@cayus.ai" className="text-[#1d4ed8] font-medium hover:underline text-sm">
              privacy@cayus.ai
            </a>
          </div>
        </div>

        {/* Company information */}
        <div className="border border-[#D9D9D9] rounded-xl p-6 sm:p-8">
          <h2 className="font-bold text-xl text-[#1B1B1B] mb-6">{c.companyTitle}</h2>

          <div className="flex flex-col gap-5">
            <div className="flex items-start gap-4">
              <Building2 className="w-5 h-5 text-[#9098A3] mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold text-[#1B1B1B]">Cayus Limited</p>
                <p className="text-sm text-[#4D4D4D]">{c.companyLegal}</p>
                <p className="text-sm text-[#4D4D4D]">{c.companyNumber}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <MapPin className="w-5 h-5 text-[#9098A3] mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold text-[#1B1B1B]">{c.officeTitle}</p>
                <p className="text-sm text-[#4D4D4D]">
                  15 Lea Road<br />
                  Sevenoaks, TN13 1QP<br />
                  United Kingdom
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Globe className="w-5 h-5 text-[#9098A3] mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold text-[#1B1B1B]">{c.websiteTitle}</p>
                <a href="https://cayus.ai" className="text-sm text-[#1d4ed8] hover:underline">cayus.ai</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    <SiteFooter />
    </div>
  );
};

export default ContactPage;
